import { Layout } from 'react-admin';
import { MlisAppBar } from './AppBar.jsx';
import { MlisMenu } from './Menu.jsx';

export const MlisLayout = (props) => (
  <Layout
    {...props}
    appBar={MlisAppBar}
    menu={MlisMenu}
  />
);
